import React, { useEffect, useState } from 'react';
import { Plus, X } from 'react-feather';
import '../../styles/cardStyles.css';
import { UsersAppointmentsGet } from 'apiServices/reducer/apiService';
import { useDispatch, useSelector } from 'react-redux';
import { FaCalendar, FaMapMarkerAlt } from 'react-icons/fa';
import AppointmentModal from 'pageComponents/dialogs/dashboard/addAppointments';
import ManageAppointmentsModal from '../dialogs/dashboard/ManageAppointmentsModal';


const UpcomingAppointmentsCard = ({
    showAddButton,
    onAdd,
    onRemove,
    widgetName,
    draggable = false,
    onDragStart,
    hideHeader = false,
    selectedFamilyMember
}) => {
    const dispatch = useDispatch();
    const userData = useSelector((state) => state.apiService.login);
    const isProvider = userData.user_type_name === 'Provider';

    // Use selectedFamilyMember's user_id if available, otherwise use current user's ID
    const userId = selectedFamilyMember?.user_id || (isProvider ? localStorage.getItem('patientUserId') : userData.user_id);
    const token = useSelector((state) => state.apiService?.token);
    const [appointmentData, setAppointmentData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showManageModal, setShowManageModal] = useState(false);

    const fetchAppointments = async () => {
        try {
            const response = await dispatch(UsersAppointmentsGet({ UserID: userId, token }));
            if (response?.payload && Array.isArray(response.payload)) {
                setAppointmentData(response.payload);
            } else {
                setAppointmentData([]);
            }
        } catch (err) {
            console.error("Failed to fetch appointments:", err);
        }
    };

    useEffect(() => {
        if (userId && token) {
            fetchAppointments();
        }
    }, [userId, token, selectedFamilyMember]);

    // Group appointments by location
    const groupAppointmentsByLocation = (appointments) => {
        const grouped = {};
        appointments.forEach(appt => {
            const locationKey = appt.location_name || 'Unknown Location';
            if (!grouped[locationKey]) {
                grouped[locationKey] = {
                    locationName: locationKey,
                    locationDetails: appt.location_details,
                    appointments: []
                };
            }
            grouped[locationKey].appointments.push(appt);
        });
        return Object.values(grouped);
    };

    const handleAddClick = () => {
        setShowModal(true);
    };

    const handleModalSave = (formData) => {
        console.log("Saved appointment data:", formData);
        fetchAppointments(); // Refresh appointments after save
        setShowModal(false);
    };

    const handleModalClose = () => {
        setShowModal(false);
    };
    const handleManageClick = () => {
        setShowManageModal(true);
    };

    const groupedAppointments = groupAppointmentsByLocation(appointmentData);

    return (
        <>
            {!hideHeader ? (
                <div
                    className="cardwidget cardwidgetHeight d-flex flex-column shadow-lg shadow-sm border-0 mb-3 rounded-3"
                    draggable={draggable}
                    onDragStart={onDragStart}
                >
                    <div className="cardwidget-header cardwidgehtHeaderBG d-flex justify-content-between align-items-center px-3 py-1">
                        <h6 className="mb-0 text-capitalize">{widgetName || "Upcoming Appointments"}</h6>
                        {showAddButton ? (
                            <button className="btn btn-sm px-0" onClick={onAdd} title="Add to Dashboard">
                                <Plus size={15} />
                            </button>
                        ) : (
                            <button className="btn btn-sm px-0" onClick={onRemove} title="Remove from Dashboard">
                                <X size={15} />
                            </button>
                        )}
                    </div>
                    <div className="cardwidget-body px-3 py-2">
                        {appointmentData.length === 0 ? (
                            <p className="text-muted">No upcoming appointments available.</p>
                        ) : (
                            groupedAppointments.map((locationGroup, locationIndex) => (
                                <div key={locationIndex} className="mb-3 appointment-card p-2 rounded border">
                                    <div className="d-flex align-items-center mb-2">
                                        <FaMapMarkerAlt className="me-1" style={{ color: 'var(--pmr-primary)' }} size={14} />
                                        <h6 className="fw-bold mb-2" style={{ color: 'var(--pmr-text-heading)' }}>{locationGroup.locationName}</h6>
                                    </div>
                                    {/* {locationGroup.locationDetails && (
                                        <div className="mb-2 text-muted">
                                            <small>
                                                <FaMapMarkerAlt className="me-1" style={{ color: 'var(--pmr-primary)' }} size={14} />
                                                {locationGroup.locationDetails
                                                    .replace(/\r\n/g, ', ')
                                                    .split(',')
                                                    .map(part => part.trim())
                                                    .filter(part => part && part.toLowerCase() !== 'string')
                                                    .join(', ')}
                                            </small>
                                        </div>
                                    )} */}
                                    {locationGroup.appointments.map((item, index) => (
                                        <div className="d-flex align-items-center me-3" key={item.appt_id}>
                                            <FaCalendar className="me-2" style={{ color: 'var(--pmr-primary)' }} size={24} />
                                            <span>
                                                <strong>Date:</strong> {item.appt_date || "N/A"} <br />
                                                <strong>Time:</strong> {item.appt_start || "N/A"} to {item.appt_end || "N/A"}
                                            </span>
                                        </div>
                                    ))}
                                    {locationIndex < groupedAppointments.length - 1 && <hr className="mt-3" />}
                                </div>
                            ))
                        )}
                    </div>

                    {!isProvider &&
                        <>
                            <div className="cardwidget-footer border-top d-flex justify-content-start px-3 py-2">
                                <button className="btn btn-link modalfooterclickeventtext p-0 me-2 text-capitalize" onClick={handleAddClick}>
                                    Add
                                </button>
                                <span className="text-muted">|</span>
                                <button className="btn btn-link modalfooterclickeventtext p-0 ms-2 text-capitalize" onClick={handleManageClick}>Manage</button>
                            </div>
                        </>
                    }
                </div>
            ) : (
                <div style={{ padding: '16px 12px' }}>
                    {appointmentData.length === 0 ? (
                        <p className="text-muted">No upcoming appointments available.</p>
                    ) : (
                        groupedAppointments.map((locationGroup, locationIndex) => (
                            <div key={locationIndex} style={{ marginBottom: '12px' }}>
                                <span>
                                    <strong>{locationGroup.locationName}</strong>
                                </span>
                                {locationGroup.appointments.map((item, index) => (
                                    <div key={item.appt_id} style={{ marginLeft: '12px', marginTop: '4px' }}>
                                        <span>
                                            <strong>Date:</strong> {item.appt_date || "N/A"} |
                                            <strong> Time:</strong> {item.appt_start || "N/A"} to {item.appt_end || "N/A"}
                                        </span>
                                    </div>
                                ))}
                                {locationGroup.locationDetails && (
                                    <div className="text-muted" style={{ fontSize: '13px', marginLeft: '12px' }}>
                                        {
                                            locationGroup.locationDetails
                                                .replace(/\r\n/g, ', ')
                                                .split(',')
                                                .map(part => part.trim())
                                                .filter(part => part && part.toLowerCase() !== 'string')
                                                .join(', ')
                                        }
                                    </div>
                                )}
                            </div>
                        ))
                    )}
                </div>
            )}

            <AppointmentModal
                show={showModal}
                onHide={handleModalClose}
                onSave={handleModalSave}
                rowData={null}
                lstLocations={[]}
                centered={true}
                userId={userId}
            />
            <ManageAppointmentsModal
                show={showManageModal}
                onHide={() => setShowManageModal(false)}
                userId={userId}
                refreshAppointments={fetchAppointments}
            />
        </>
    );
};

export default UpcomingAppointmentsCard;